import { ICellRendererParams } from 'ag-grid-community'

import type { CompanyRow } from '@/pages/third-party-inventory/ag-grid-inventory/types'

import { InherentRiskIcon } from '@/components/shared/inherent-risk-icon/inherent-risk-icon'
import { toDisplayRisk } from '@/components/shared/risk-badge/utils'

export const RiskCell = (props: ICellRendererParams<CompanyRow>) => {
  if (!props.data) return null
  const risk = toDisplayRisk(props.data.validatedRisk, props.data.calculatedRisk)

  return (
    <div className='border-default flex size-full items-center justify-center'>
      <InherentRiskIcon risk={risk} />
    </div>
  )
}
